<div class="modal-overlay" *ngIf="isVisible" (click)="onClose()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2 class="modal-title">Escolha seu Plano</h2>
      <button class="close-button" (click)="onClose()">
        <i class="fas fa-times"></i>
      </button>
    </div>
    
    <!-- Tabs de Categorias -->
    <div class="category-tabs" *ngIf="categories.length > 1">
      <button 
        *ngFor="let category of categories; let i = index"
        class="tab-button"
        [class.active]="selectedCategoryIndex === i"
        (click)="selectCategory(i)">
        {{ category.name }}
      </button>
    </div>

    <div class="modal-body">
      <p class="modal-description" *ngIf="selectedCategory?.description">
        {{ selectedCategory?.description }}
      </p>
      
      <div class="plans-list">
        <div class="plan-item" *ngFor="let plan of selectedCategory?.plans">
          <div class="plan-item-content" (click)="onSelectPlan(plan.id)">
            <div class="plan-item-left">
              <div class="plan-image-small" *ngIf="plan.imgPortalPlan?.id">
                <img [src]="getImageUrl(plan.imgPortalPlan?.id)" [alt]="plan.planName || plan.name">
              </div>
              <div class="plan-info">
                <h4 class="plan-name-small">{{ plan.planName || plan.name }}</h4>
                <p class="plan-period" *ngIf="plan.description">{{ plan.description }}</p>
              </div>
            </div>
            
            <div class="plan-item-right">
              <div class="plan-price-small">
                <ng-container *ngIf="plan.amount === 0 || plan.amount === null || plan.amount === undefined; else showPrice">
                  Gratuito
                </ng-container>
                <ng-template #showPrice>
                  {{ (plan.amount ?? 0) | customCurrency }}<span class="period">/mês</span>
                </ng-template>
              </div>
              <button class="select-button-small">
                Selecionar
                <i class="fas fa-arrow-right"></i>
              </button>
            </div>
          </div>

          <!-- Seção de Benefícios Diferenciais -->
          <div class="benefits-section" *ngIf="hasDiferencialBenefits(plan)">
            <button class="benefits-toggle" (click)="toggleBenefits(plan.id, $event)">
              <span>Benefícios</span>
              <i class="fas fa-chevron-down" [class.rotated]="isPlanExpanded(plan.id)"></i>
            </button>
            
            <div class="benefits-list" *ngIf="isPlanExpanded(plan.id)">
              <div class="benefit-item" *ngFor="let benefit of getDiferencialBenefits(plan)">
                <i class="fas fa-check-circle"></i>
                <span>{{ benefit.benefitName }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
